var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.valid)?_c('Footer',{staticClass:"j-section-footer",attrs:{"data-spm-module":(_vm.inhouseModule + "?trg=manual"),"data-business-name":_vm.name,"more-title":_vm.moreTitle,"more-deep-link":_vm.link}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }